module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-180x180-13c2704ca90bd8da2858dcd4cc9e7442.png";